import { routeApis } from "../../constants/apis";
import { Routes } from "../../constants/routes";
import { getPageData } from "../templates/page";

export const clientPortalSalesforceCampaignsLoader = async (props: any) => {
  return getPageData({
    url: routeApis[Routes.CLIENT_PORTAL_SALESFORCE_CAMPAIGNS]
      .getSalesforceCampaigns,
    ...props,
  });
};
